export const creditRulesOptions = {
    DeliAriesCreditOptEnum: [
        {
            label: "加分",
            value: 'PLUS'
        },
        {
            label: "扣分",
            value: 'REDUCE'
        },
    ],
    deliAriesCreditManualEnum: [
        {
            label: "加分",
            value: 'PLUS'
        },
    ],
    deliAriesPersonnelAllocationEnum: [
        {
            label: "6-10人",
            value: 'LIMIT_TEN'
        },
        {
            label: "11-20人",
            value: 'LIMIT_TWENTY'
        },
        {
            label: "21人以上",
            value: 'OVAR_TWENTY'
        },
        {
            label: "有专职财务人员",
            value: 'FULL_FINANCE'
        },
    ],
    DeliAriesGuaranteeQualificationEnum: [
        {
            label: "25-50岁",
            value: 'ONE'
        },
        {
            label: "有房产",
            value: 'TWO'
        },
        {
            label: "有车辆",
            value: 'THREE'
        },

    ],
    DeliAriesOverdueRecordsEnum: [
        {
            label: "10-50000",
            value: 'LILIT_FIFTY_THOUSAND'
        },
        {
            label: "50000以上",
            value: 'OVER_FIFTY_THOUSAND'
        },
        {
            label: "累计逾期",
            value: 'CUMULATIVE'
        },
    ],
    DeliAriesDurationCooperationEnum: [
        {
            label: "3年以下",
            value: 'LIMIT_THREE'
        },
        {
            label: "3(含)-5(不含)年",
            value: 'LIMIT_FIVE'
        },
        {
            label: "5(含)-10(不含)年",
            value: 'LIMIT_TEN'
        },
        {
            label: "10(含)年以上",
            value: 'OVER_TEN'
        },
    ],
    DeliAriesCreditManualEnum:[
        {
            label:'实控人存在赌博、乱投资等不良行为',
            value:'BAD_BEHAVIOR'
        },
        {
            label:'实控人家庭是否有重大变故',
            value:'SEVERE_CALAMITY'
        },
        {
            label:'其他事项',
            value:'OTHERS'
        },
    ]
}
// {
// label: "",
// value: ''
// },